import React, { useState } from "react";
import { motion } from "framer-motion";

const Indicator = ({
  isActive,
  activeColor = "#ffffff",
  inActiveColor = "#cbd5e1",
  ...rest
}) => {
  const [isHovered, setIsHovered] = useState(false);

  const draw = {
    hidden: {
      pathLength: 0,
      opacity: 0,
      transition: {
        pathLength: { type: "spring", duration: 2, bounce: 0 },
        opacity: { type: "spring", duration: 2 },
      },
    },
    visible: {
      pathLength: 1,
      opacity: 1,
      transition: {
        pathLength: { type: "spring", duration: 1, bounce: 0 },
        opacity: { type: "spring", duration: 1 },
      },
    },
    exit: {
      pathLength: 0,
      opacity: 0,
      transition: {
        pathLength: { type: "spring", duration: 1, bounce: 0 },
        opacity: { type: "spring", duration: 1 },
      },
    },
  };

  const image = {
    maxWidth: "10vw",
  };

  const shape = {
    strokeWidth: 1.5,
    strokeLinecap: "round",
    fill: "transparent",
  };

  return (
    <motion.svg
      width="50"
      height="50"
      viewBox="0 0 50 50"
      style={image}
      {...rest}
    >
      <motion.circle
        className="circle-path"
        cx="25"
        cy="25"
        r="20"
        stroke={isActive || isHovered ? activeColor : inActiveColor}
        variants={draw}
        initial="hidden"
        animate={isActive ? "visible" : isHovered ? "visible" : "hidden"}
        exit="exit"
        style={shape}
      />
      <motion.rect
        x="22"
        y="22"
        width="6"
        height="6"
        fill={isActive || isHovered ? activeColor : inActiveColor}
        className="cursor-pointer"
        whileHover={{
          rotate: 45,
          transition: { type: "spring", stiffness: 300 },
        }}
        style={{ transformOrigin: "50% 50%", rotate: 45 }}
        onHoverStart={() => setIsHovered(true)}
        onHoverEnd={() => setIsHovered(false)}
      />
    </motion.svg>
  );
};

export default React.memo(Indicator);
